export enum FeesPerformanceScope {
  Including = "Including",
  Excluding = "Excluding",
}
